/* Boreal Gaming — product page extras (snippets/boreal-pdp-extras.liquid).
   1. "Complete the set" in the buy box: same-type, in-stock items from Shopify's
      product recommendations, each with a one-tap Add.
   2. Phone sticky Add to cart bar: appears once the main Add to cart button has
      scrolled above the top of the screen, and presses that button when tapped. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
              .replace(/\{\{\s*amount\s*\}\}/, withCommas)
              .replace(/<[^>]*>/g, '');
  }

  function img(src, w) {
    if (!src) return '';
    var s = src.indexOf('//') === 0 ? 'https:' + src : src;
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- Complete the set ---------- */
  var box = document.querySelector('[data-bm-addons]');
  if (box && window.fetch) {
    var pid = box.getAttribute('data-product-id');
    var type = box.getAttribute('data-type');
    fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=10')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var list = box.querySelector('[data-bm-addons-list]');
        var picks = (data.products || []).filter(function (p) {
          return p.available && String(p.id) !== pid && p.type === type;
        }).slice(0, 3);
        if (!picks.length) return;
        picks.forEach(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return;
          var li = document.createElement('li');
          li.className = 'bm-pdp-addons__item';
          var a = document.createElement('a');
          a.className = 'bm-pdp-addons__media';
          a.href = p.url;
          a.setAttribute('aria-hidden', 'true');
          a.tabIndex = -1;
          if (p.featured_image) {
            var im = document.createElement('img');
            im.src = img(p.featured_image, 120);
            im.alt = '';
            im.loading = 'lazy';
            a.appendChild(im);
          }
          var t = document.createElement('span');
          t.className = 'bm-pdp-addons__text';
          var name = document.createElement('a');
          name.className = 'bm-pdp-addons__name';
          name.href = p.url;
          name.textContent = p.title.indexOf(' - ') > -1 ? p.title.split(' - ').pop() : p.title;
          var price = document.createElement('span');
          price.className = 'bm-pdp-addons__price';
          price.textContent = money(v.price);
          t.appendChild(name);
          t.appendChild(price);
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'bm-pdp-addons__add';
          b.textContent = 'Add';
          b.setAttribute('aria-label', 'Add ' + p.title + ' to cart');
          b.addEventListener('click', function () {
            b.disabled = true;
            b.textContent = 'Adding…';
            fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
            }).then(function (r) {
              if (!r.ok) throw new Error('add');
              b.textContent = 'Added';
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
              if (typeof window.updateItemCount === 'function') { try { window.updateItemCount(); } catch (e) {} }
            }).catch(function () {
              b.disabled = false;
              b.textContent = 'Add';
            });
          });
          li.appendChild(a);
          li.appendChild(t);
          li.appendChild(b);
          list.appendChild(li);
        });
        if (list.children.length) box.hidden = false;
      })
      .catch(function () {});
  }

  /* ---------- Phone sticky Add to cart ---------- */
  var bar = document.querySelector('[data-bm-sticky]');
  var main = document.querySelector('.product-form__add-button');
  if (bar && main) {
    var phone = window.matchMedia('(max-width: 999px)');
    var btn = bar.querySelector('[data-bm-sticky-add]');
    var ticking = false;

    function sync() {
      ticking = false;
      var label = (main.textContent || '').trim();
      if (label) btn.textContent = label;
      var past = main.getBoundingClientRect().bottom < 0;
      var show = phone.matches && past && main.offsetParent !== null && !main.disabled;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(sync); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    sync();
    if (phone.addEventListener) phone.addEventListener('change', sync);
    btn.addEventListener('click', function () { main.click(); });
  }
})();
